import { User } from '../user/User'
import { CalendarTravelEntry } from './CalendarTravelEntry'

export class CalendarDateEntry {
  constructor ({ user = {}, travel = {} } = {}) {
    this.user = new User(user)
    this.travel = new CalendarTravelEntry(travel)
  }
}
